module.exports = __webpack_public_path__ + "static/img/cont58_07.f4d11ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_07.jpg
// module id = WxEl
// module chunks = 0